import { TipoDeRecurso } from '@/models/Recurso';
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from 'vue-router';

const rotas: RouteConfig[] = [
	{
		path: 'consulta-de-preco',
		name: 'Consulta de preço',
		components: {
			default: () =>
				import('@/views/application/produtos/TelaDeConsultaDePreco.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'consulta-de-preco' as TipoDeRecurso,
		},
	},
]

export default rotas